<template lang="html">
  <section class="contact">
    <h1 class="title" v-if="true"><span>Contact</span></h1>
    <div class="contact__footer">
      <div class="contact__footerItem" v-for="contactGroup in pageCopy.contacts">
        <h3 class="contact__footerTitle">{{contactGroup.country}}</h3>
        <h3 class="contact__footerSubtitle" v-html="contactGroup.address.join('<br />')"></h3>
        <p class="contact__footerInfo" v-for="contact in contactGroup.contacts">{{contact}}</p>
      </div>
      <div class="contact__footerItem">
        <h4 class="contact__footerSubtitle">{{pageCopy.newsletterCopy}}</h4>
        <div class="inputBox" :class="{error:newsletterError || newsletterInputError,success:newsletterSuccess}">
          <input type="email" :placeholder="pageCopy.newsletterPlaceholder" v-model="newsletter" @keydown="submitNewsletter">
          <img class="contact__submit hover" src="../assets/submit.svg" alt="submit" @click="submitNewsletter">
          <p v-if="newsletterInputError">{{pageCopy.newsletterInputErrorMessage}}</p>
          <p v-if="newsletterSuccess">{{pageCopy.newsletterSuccessMessage}}</p>
          <p v-if="newsletterError">{{pageCopy.newsletterErrorMessage}}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import anime from "animejs";

export default {
  name: "Contact",
  mounted() {
    setTimeout(() => {
      anime({
        targets: ".contact__footerItem",
        opacity: [0, 1],
        duration: 1000,
        easing: "easeInOutCubic",
        delay: function(el, i) {
          return 300 * i + 1000;
        }
      });
    }, 400);
  },
  data() {
    return {
      newsletter: "",
      emailRegex: /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
      newsletterError: false,
      newsletterSuccess: false,
      newsletterInputError: false
    };
  },
  methods: {
    submitNewsletter(e) {
      this.newsletterError = false;
      this.newsletterSuccess = false;
      this.newsletterInputError = false;
      if (e.keyCode === 13 || e.type === "click") {
        if (this.newsletter.match(this.emailRegex)) {
          this.$store
            .dispatch("subscribeNL", this.newsletter)
            .then(response => {
              this.newsletterSuccess = true;
              setTimeout(() => {
                this.newsletterSuccess = false;
                this.newsletter = "";
              }, 2000);
            })
            .catch(error => {
              this.newsletterSuccess = false;
              this.newsletterError = true;
            });
        } else this.newsletterInputError = true;
      }
    }
  },
  computed: {
    pageCopy() {
      return this.$store.state.contactsCopy;
    }
  }
};
</script>

<style lang="scss">
@import "../styles/config.scss";
.contact {
  max-width: 840px;
  span {
    display: inline-block;
  }
  &__submitButton {
    //position: absolute;
    //top: 0;
    //right: 0;
    background-color: transparent;
    border: none;
    //padding: 0;
    margin-left: 40px;
    font-family: CamptonBold;
    font-size: 20px;
    color: var(--Neu01);
    overflow: hidden;
    transition: color 0.2s ease-out;
    &:before {
      content: url("../assets/submit.svg");
      right: 10px;
      top: 3px;
      position: relative;
    }
  }
  &__form {
    margin: 80px 0;
    max-width: 500px;
    form {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      height: 130px;
    }
    .inputBox {
      position: absolute;
    }
  }
  &__formFooter {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 20px;
  }
  &__dot {
    border-radius: 5px;
    border: 1px solid var(--Neu01);
    width: 6px;
    height: 6px;
    margin-right: 10px;
    display: inline-block;
    vertical-align: middle;
    transition: border-color 0.2s ease-in, width 0.3s ease-in;
    &.selected {
      border-color: var(--M01);
      width: 50px;
      transition: border-color 0.2s ease-in 0.3s,
        width 0.6s cubic-bezier(0.41, 0.15, 0.41, 1.31) 0.2s;
    }
  }
  &__formBack,
  &__formNext {
    background-color: transparent;
    border: none;
    //padding: 0;
    margin: 0;
    font-family: CamptonBold;
    font-size: 20px;
    color: var(--Neu01);
    overflow: hidden;
    margin-left: 40px;
    transition: color 0.2s ease-out;
    &.faded {
      color: var(--Neu06);
    }
  }
  &__success {
    .title:last-of-type {
      top: -30px;
    }
    p {
      font-family: CamptonBook;
      font-size: 20px;
      line-height: 1.35;
      color: var(--Neu01);
      span {
        display: inline-block;
        position: relative;
        &:before {
          content: "";
          position: absolute;
          bottom: 2px;
          height: 4px;
          animation: highlight 0.3s ease-out forwards 1s;
          z-index: -1;
          background-color: var(--M01);
        }
      }
    }
  }
  &__footer {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-row-gap: 40px;
    grid-column-gap: 40px;
    margin-top: 100px;
  }
  &__footerItem {
    &:last-of-type {
      grid-area: 2 / 3 / 3 /4;
    }
    .inputBox input[type="email"] {
      width: 100%;
    }
  }
  &__footerTitle {
    font-family: CamptonBold;
    font-size: 16px;
    color: var(--Neu01);
    margin-bottom: 15px;
  }
  &__footerSubtitle {
    font-family: CamptonBook;
    font-size: 14px;
    line-height: 1.29;
    color: var(--Neu06);
    margin-bottom: 20px;
  }
  &__footerInfo {
    font-family: CamptonBook;
    font-size: 16px;
    line-height: 1.13;
    color: var(--Neu01);
    margin-bottom: 10px;
  }
  &__socialMedia {
    text-align: right;
    padding: 40px 0;
  }
  &__submit {
    width: 34px;
    position: absolute;
    right: 0;
    top: 50px;
  }
  .inputBox {
    min-height: 130px;
    textarea,
    input[type="text"],
    input[type="email"] {
      border: 0;
      color: var(--Neu01);
      background-color: transparent;
      resize: none;
      font-family: CamptonBook;
      padding: 10px 0;
    }
    textarea {
      font-size: 18px;
      line-height: 1.5;
      width: 100%;
    }
    input[type="text"],
    input[type="email"] {
      border-bottom: 1px solid var(--Neu06);
      font-size: 16px;
      width: 250px;
    }
    p {
      font-family: CamptonBook;
      color: var(--M01);
      font-size: 12px;
      margin-top: 5px;
      transition: opacity 0.2s ease-out;
    }
    &.error {
      input {
        border-color: var(--M01);
        color: var(--M01);
      }
      textarea {
        color: var(--M01);
      }
      p {
        color: var(--M01);
      }
    }
    &.success {
      p {
        color: var(--M02);
      }
    }
  }
  @include mq(0, 768px) {
    &__form {
      margin: 40px 0;
      form {
        height: 110px;
      }
    }
    &__submitButton {
      top: auto;
      bottom: 0;
    }
    &__footer {
      margin-top: 0;
      grid-template-columns: 1fr;
    }
    &__footerItem {
      margin-top: 40px;
      &:last-of-type {
        grid-area: auto;
      }
    }
    &__socialMedia {
      padding: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/containers/Contact.vue